module.exports = __webpack_public_path__ + "img/accountList.2606555b.svg";